import { includes, map } from 'lodash/fp';
import constants from '@ahmdigital/constants';

import { CustomerActionType, StateValues } from '../../actions/customer';
import { EXCESS_TYPES } from '../../ahm-constants/ui';
import { FIELD_NAMES, INCOME_TIER_NONE } from '../../components/pricing-drawer/constants';
import { SCALE_OPTIONS, SCALES_WITH_PARTNER } from '../../models/customer/constants';
import getDateOfBirthFromAge from '../get-date-of-birth-from-age';
import uncapFpIterator from '../../../utils/uncap-fp-iterator';
import type { FieldNames, PricingDrawerActions } from '../../components/pricing-drawer/types';

const { AGE, FREQUENCY, HOSPITAL_EXCESS, INCOME_TIER, INCOME_TYPE, PARTNER_AGE, SCALE, STATE } = FIELD_NAMES;
const { RELATIONSHIP } = constants;

const mapWithIndex = uncapFpIterator(map);

type Params = {
  // TODO: [AP-1626] I don't think this OR type is right. I think it can optionally have PricingDrawerActions as this is re-used in pricing drawer and can update customer AND dispatch to close the drawer
  actions: PricingDrawerActions | CustomerActionType;
  rebate: Boolean;
  updatedFields: {
    [key in FieldNames]?: string;
  };
  scale: string;
};

const submitUpdatedRefineFields = ({ actions, rebate, updatedFields, scale }: Params) => {
  const scaleForPartnerAge = updatedFields.scale || scale;
  mapWithIndex((value: string, key: string) => {
    if (key === AGE) {
      const clientDateOfBirth = getDateOfBirthFromAge(value);
      actions.customer.changeDateOfBirth(clientDateOfBirth, RELATIONSHIP.CLIENT);
    }
    if (key === FREQUENCY && includes(value, constants.PAYMENT_FREQUENCY)) {
      actions.customer.changeFrequency(value);
    }
    if (
      key === HOSPITAL_EXCESS &&
      includes(
        value,
        EXCESS_TYPES.map((excess) => excess.toString()),
      )
    ) {
      actions.customer.changeHospitalExcess(value);
    }
    if (key === INCOME_TIER && value !== INCOME_TIER_NONE && includes(value, constants.INCOME_TIER)) {
      actions.customer.changeRebate(true);
      actions.customer.changeIncomeTier(value);
    }
    if (key === INCOME_TIER && rebate === true && value === INCOME_TIER_NONE) {
      actions.customer.changeRebate(false);
    }
    if (key === INCOME_TYPE && includes(value, constants.INCOME_TYPE)) {
      actions.customer.changeIncomeType(value);
    }
    if (key === PARTNER_AGE && includes(scaleForPartnerAge, SCALES_WITH_PARTNER)) {
      const spouseDateOfBirth = getDateOfBirthFromAge(value);
      actions.customer.changeDateOfBirth(spouseDateOfBirth, RELATIONSHIP.SPOUSE);
    }
    if (key === SCALE && includes(value, SCALE_OPTIONS)) {
      actions.customer.changeScale(value as (typeof SCALE_OPTIONS)[number]);
    }
    if (key === STATE && includes(value, constants.STATE)) {
      actions.customer.changeState(value as StateValues);
    }
  }, updatedFields);
  return null;
};

export default submitUpdatedRefineFields;
